import logo from "../../../../public/projects/Majestique/images/logo/logo.png"
import evolvus from "../../../../public/projects/Majestique/images/projects/Evolvus.jpg"
export const developerMajestique = {
  
  properties: [
    {
      name: "Majestique Evolvus",
      image: evolvus,
      price: "On Request",
      state:"Pune",
      developer:"Majestique",
      projectlocation:"West Pune",
      location: "Kharadi",
      bed: "2 - 3 - 4 BHK ",
      size: "....",
      url: ``,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    }, 
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1992",
  },
  about: `Founded by Dwarkadas Maheshwari in 1992 as a textile company, Majestique Landmarks entered the Pune real estate market in 2007 and focuses on developing residential projects that appeal to a variety of demographics. The company's goal is to establish itself as a leading brand in the real estate sector, recognized for its quality, transparency, and on-time delivery.
`,
};

